export function isViewRequiredYes(viewRequired) {
  return (
    viewRequired === true ||
    viewRequired === "Y" ||
    viewRequired === "y"
  );
}

/**
 * Default auto-generate VIEW copy toggle for working-document check-in only.
 * Used by ViewCopyAccordion and fetchDocumentRevisionInfo — not new/bulk check-in flows.
 * @param {boolean|null} [params.isViewCopyExists] - IFS VIEW row exists (from revision info API).
 * @param {boolean|string} params.viewRequired - Doc class requires view copy.
 * @param {boolean} params.isWordLike - DOC/DOCX/DOCM.
 * @param {number} [params.uploadViewCopyCount]
 * @returns {boolean}
 */
export function resolveCreateViewCopyDefault({
  isViewCopyExists = null,
  viewRequired,
  isWordLike = false,
  uploadViewCopyCount = 0,
}) {
  if (
    uploadViewCopyCount !== undefined &&
    uploadViewCopyCount !== null &&
    uploadViewCopyCount > 0
  ) {
    return false;
  }

  if (typeof isViewCopyExists === "boolean") {
    if (isViewCopyExists === true) {
      // Auto-generate applies to Word only; non-Word docs need a manual PDF upload.
      return isWordLike;
    }
    return isViewRequiredYes(viewRequired) ? isWordLike : false;
  }

  return isViewRequiredYes(viewRequired) ? isWordLike : false;
}
